<template>
  <div class="tw-mt-3 tw-flex tw-text-lg tw-text-white">
    <template v-if="page.options.buttons === 'profile' || page.options.buttons === 'profile+actions'">
      <template v-if="buttonType === 'icon'">
        <a
          v-if="matchState === 'default'"
          class="tw-ml-2 btn-circle btn-circle-md send-icebreaker-btn"
          :class="page.options.sectionClass"
          title="Send Icebreaker"
          role="button"
          @click="userAction('icebreaker:send')"
        >
          <i
            class="fas fa-ice-cream"
            aria-hidden="true"
          />
        </a>
        <a
          v-if="matchState === 'inviteSent'"
          class="tw-ml-2 btn-circle btn-circle-md cancel-invite-btn"
          :class="page.options.sectionClass"
          title="Cancel Icebreaker"
          role="button"
          @click="userAction('invite:cancel')"
        >
          <i
            class="fas fa-times-circle-o"
            aria-hidden="true"
          />
        </a>
        <a
          v-if="matchState === 'inviteReceived'"
          class="tw-ml-2 btn-circle btn-circle-md accept-invite-btn rainbow-bg"
          :class="page.options.sectionClass"
          title="Accept Icebreaker"
          role="button"
          @click="userAction('invite:accept')"
        >
          <i
            class="fas fa-ice-breaker"
            aria-hidden="true"
          />
        </a>
        <a
          v-if="matchState === 'matched'"
          class="tw-ml-2 btn-circle btn-circle-md chat-now-btn"
          :class="page.options.sectionClass"
          title="Chat Now"
          role="button"
          @click="userAction('chat')"
        >
          <i
            class="fas fa-comments"
            aria-hidden="true"
          />
        </a>
      </template>

      <template
        v-else-if="buttonType === 'text'"
        class="tw-flex"
      >
        <a
          v-if="matchState === 'default'"
          class="tw-ml-2 btn-circle btn-circle-md"
          :class="page.options.sectionClass"
          title="Send Icebreaker"
          role="button"
          @click="userAction('icebreaker:send')"
        >Invite</a>
        <a
          v-if="matchState === 'inviteSent'"
          class="tw-ml-2 btn-circle btn-circle-md"
          :class="page.options.sectionClass"
          title="Cancel Icebreaker"
          role="button"
          @click="userAction('invite:cancel')"
        >Cancel</a>
        <a
          v-if="matchState === 'inviteReceived'"
          class="tw-ml-2 btn-circle btn-circle-md"
          :class="page.options.sectionClass"
          title="Accept Icebreaker"
          role="button"
          @click="userAction('invite:accept')"
        >Accept</a>
        <a
          v-if="matchState === 'matched'"
          class="tw-ml-2 btn-circle btn-circle-md"
          :class="page.options.sectionClass"
          title="Chat Now"
          role="button"
          @click="userAction('chat')"
        >Chat Now</a>
      </template>

      <template v-if="page.options.profileTemplate === 'small' || page.options.profileTemplate === 'full'">
        <a
          class="tw-ml-2 btn-circle btn-circle-md star-btn"
          :class="page.options.sectionClass"
          role="button"
          style="cursor: pointer;"
          @click="star"
        >
          <i
            :class="starClass"
            aria-hidden="true"
          />
        </a>
      </template>

      <template
        v-if="page.options.buttons === 'profile+actions'"
        class="dropdown btn-group-autopos"
      >
        <dropdown-button :btn-class="page.options.sectionClass">
          <a
            role="button"
            class="tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
            @click="userAction('user:report')"
          > Report </a>

          <a
            v-if="matchState === 'inviteReceived'"
            class="tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
            role="button"
            @click="userAction('invite:hide')"
          > Hide </a>

          <!-- <a -->
          <!-- class="tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600" -->
          <!-- role="button" -->
          <!-- @click="userAction('block')" -->
          <!-- > Block </a> -->

          <a
            v-if="matchState === 'matched'"
            class="tw-block tw-px-2 tw-py-1 tw-leading-tight tw-text-gray-800 hover:tw-bg-gray-200 hover:tw-text-gray-600"
            role="button"
            @click="userAction('user:unmatch')"
          > Unmatch </a>
        </dropdown-button>
      </template>

      <ProfileAdminDropdown
        v-if="isAdmin"
        :data="data"
        :btn-class="page.options.sectionClass"
      />
    </template>

    <!-- <Modal -->
    <!-- :id="modalId" -->
    <!-- :options="modalOptions" -->
    <!-- > -->
    <!-- <div class="modal-header"> -->
    <!-- <h4 -->
    <!-- class="tw-text-xl" -->
    <!-- v-text="titleText" -->
    <!-- /> -->
    <!-- </div> -->
    <!-- <div class="modal-body"> -->
    <!-- {{ bodyText }} -->
    <!--  -->
    <!-- <div v-if="activeModal === 'icebreaker:send'"> -->
    <!-- wheee -->
    <!-- </div> -->
    <!--  -->
    <!-- <div v-else-if="activeModal === 'user:report'"> -->
    <!-- <vue-form-generator -->
    <!-- ref="reportForm" -->
    <!-- :schema="reportSchema" -->
    <!-- :model="reportForm" -->
    <!-- /> -->
    <!-- </div> -->
    <!--  -->
    <!-- <div v-else-if="activeModal === 'user:ban'"> -->
    <!-- <vue-form-generator -->
    <!-- ref="banForm" -->
    <!-- :schema="banSchema" -->
    <!-- :model="banForm" -->
    <!-- /> -->
    <!-- </div> -->
    <!--  -->
    <!-- <div v-else-if="activeModal === 'user:ghostMessage'"> -->
    <!-- <vue-form-generator -->
    <!-- ref="ghostMessageForm" -->
    <!-- :schema="ghostMessageSchema" -->
    <!-- :model="ghostMessageForm" -->
    <!-- /> -->
    <!-- </div> -->
    <!-- </div> -->
    <!-- <div class="modal-footer"> -->
    <!-- <button -->
    <!-- type="button" -->
    <!-- class="tw-ml-2 btn btn-lg btn-white" -->
    <!-- :class="page.options.sectionClass" -->
    <!-- @click="cancelClick" -->
    <!-- v-text="cancelText" -->
    <!-- /> -->
    <!-- <button -->
    <!-- type="button" -->
    <!-- class="tw-ml-2 btn btn-lg btn-white" -->
    <!-- :class="page.options.sectionClass" -->
    <!-- @click="okClick" -->
    <!-- v-text="okText" -->
    <!-- /> -->
    <!-- </div> -->
    <!-- </Modal> -->
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

import actionHelpers from '@/mixins/helpers/action-helpers';
import permissions from '@/mixins/permissions';

export default {
  components: {
    ProfileAdminDropdown: () => import(/* webpackChunkName: "components--filters--admin" */ '@/components/buttons/ProfileAdminDropdown'),
  },

  mixins: [
    permissions, //
    actionHelpers,
  ],

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      starred: '',
      // activeModal: 'icebreaker_send',
      modalOptions: {
        size: 'md',
      },
    };
  },

  computed: {
    ...sync([
      'page', //
    ]),

    modalId() {
      return `profile-action-${this.data.id}`;
    },

    matchState() {
      // console.log("profile-modals.matchState.data", this.data);

      let matchState = 'default';

      if (this.data.matched) {
        matchState = 'matched';
      } else if (this.data.inviteSent) {
        matchState = 'inviteSent';
      } else if (this.data.inviteReceived) {
        matchState = 'inviteReceived';
      }

      // console.log('profile-modals.matchState.matchState', matchState);

      return matchState;
    },

    starClass() {
      return this.data.starred ? 'fas fa-star' : 'far fa-star';
    },

    buttonType() {
      if (this.page.options.profileTemplate === 'small' || this.page.options.profileTemplate === 'full') {
        return 'icon';
      }
      return 'text';
    },
  },

  methods: {
    star() {
      console.log('star', this.data);
      axios
        .post('/api/match/star', {
          id: this.data.profile.userId,
        })
        .then((response) => {
          Bus.$emit('refresh');
          this.data.starred = response.data.liked;
        });
    },
  },
};
</script>

<style>
.search.send-icebreaker-btn {
  @apply tw-bg-custom-red;
}
.search.star-btn {
  @apply tw-bg-custom-blue;
}
.search.chat-now-btn {
  @apply tw-bg-custom-blue;
}

.rainbow-bg {
background: -moz-radial-gradient(center, ellipse cover, rgba(153,218,255,1) 0%, rgba(0,128,128,1) 100%); /* ff3.6+ */
background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%, rgba(153,218,255,1)), color-stop(100%, rgba(0,128,128,1))); /* safari4+,chrome */
background:-webkit-radial-gradient(center, ellipse cover, rgba(153,218,255,1) 0%, rgba(0,128,128,1) 100%); /* safari5.1+,chrome10+ */
background: -o-radial-gradient(center, ellipse cover, rgba(153,218,255,1) 0%, rgba(0,128,128,1) 100%); /* opera 11.10+ */
background: -ms-radial-gradient(center, ellipse cover, rgba(153,218,255,1) 0%, rgba(0,128,128,1) 100%); /* ie10+ */
background:radial-gradient(ellipse at center, rgba(153,218,255,1) 0%, rgba(0,128,128,1) 100%); /* w3c */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#99DAFF', endColorstr='#008080',GradientType=0 ); /* ie6-9 */
}
</style>
